export function video() {
    let videoHolder = $(".video-section");
    let videoLink = videoHolder.find("a");
    const src = videoLink.attr("href") + '?enablejsapi=1&autoplay=0&controls=0&mute=1&rel=0&loop=1';
    const video = '<iframe src="' + src + '" frameborder="0" allow="autoplay"  allowfullscreen playsinline></iframe>'
    videoHolder.append(video);
    $(document).on("click", function (e) {
        if ($(e.target)[0] === $(".play-video")[0]) {
            e.preventDefault();
            if ($("body").hasClass(".touch")) {
                videoHolder.addClass("video-play played");
            } else {
                if (!videoHolder.hasClass("video-play")) {
                    videoHolder.find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
                    videoHolder.addClass("video-play played");
                    videoLink.addClass('paused');
                } else if (videoHolder.hasClass("played")) {
                    videoHolder.find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
                    videoHolder.removeClass("played");
                    videoLink.removeClass('paused');
                } else {
                    videoHolder.find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
                    videoHolder.addClass("played");
                    videoLink.addClass('paused');
                }
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/video.js